import * as React from 'react';

export const TransformFont = (props: any) => {
    let font: string = String(props.font);
    if (!font) return null;
    let FontArr: any[] = font.split('.');
    return (
        <div className={`${props.class}`}>
            {
                FontArr[0] && <span style={{fontSize: (props.firstSize || null), lineHeight: (props.firstSize || null)}}>{FontArr[0]}</span>
            }
            {
                FontArr[1] && (
                    <span style={{fontSize: (props.secondsSize || null)}}>.{FontArr[1]}</span>
                )
            }
        </div>
    )
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/transformComp/transformFont.tsx